import { z } from 'zod'
import { useZorm } from 'react-zorm'
import {
    FormField,
    fieldDescription,
    withProps,
} from '@codecorp/zorm-conventions'
import { ShowBarcode } from '../components/show-barcode'
import { CreatorButtons } from '../components/creator-buttons'
import { sms } from '@codecorp/barcode-data-generator'
import { useFormReset } from '../hooks/use-form'
import { useShowModal } from '../hooks/use-show-modal'

const FormSchema = z.object({
    label: z.string().describe(
        fieldDescription({
            placeHolder: 'This name will be placed under the QR Code.',
        })
    ),
    recipient: z.string().describe(fieldDescription({ inputType: 'tel' })),
    message: z
        .string()
        .optional()
        .describe(fieldDescription({ placeHolder: 'Enter your text here' })),
})

export const SmsBarcodeCreator = () => {
    const { setSubmittedBarcode, handleFormReset } = useFormReset(undefined)
    const showModal = useShowModal()

    const zo = useZorm('smsBarcode', FormSchema, {
        onValidSubmit: async ({ preventDefault, data }) => {
            preventDefault()

            setSubmittedBarcode(data)
            showModal(
                <ShowBarcode
                    label={data.label}
                    barcode={sms(data.recipient, data.message)}
                />
            )
        },
    })

    return (
        <div>
            <form
                ref={zo.ref}
                className="ml-10 mr-10 leading-10"
                onReset={handleFormReset}
            >
                {zo.fields.label(FormField)}
                {zo.fields.recipient(
                    withProps({ defaultValue: '+1' }, FormField)
                )}
                {zo.fields.message(FormField)}
                <CreatorButtons />
            </form>
        </div>
    )
}
